<template>
  <!-- start::component container -->
  <div id="page-user-list">

    <!-- start::filter card -->
    <vx-card ref="filterCard" title="Φίλτρα" class="user-list-filters mb-8" collapseAction refreshContentAction
             @refresh="resetColFilters" isContentCollapsed="true">
      <validation-observer v-slot="{invalid}">
        <form>
          <div class="vx-row">

            <!-- start::field date -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <validation-provider rules="required" v-slot="{ errors }">
                <label class="text-sm opacity-75">Ημερομηνία</label>
                <flat-pickr v-model="date" :config="{enable: activeDates }"
                            @input="findCrawlingSetsPerDate" class="w-full" name="date"/>
                <div class="text-error text-right">{{ errors[0] }}</div>
              </validation-provider>
            </div>
            <!-- end::field date -->

            <!-- start::field time -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <label class="text-sm opacity-75">Ώρα</label>
              <v-select :options="hours" label="hours" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="selectedHour" class="mb-4 md:mb-0"/>
            </div>
            <!-- end::field time -->

            <!-- start::field market place -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <label class="text-sm opacity-75">Πηγές</label>
              <v-select :options="eshops" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="selectedEshop" class="mb-4 md:mb-0"/>
            </div>
            <!-- end::field market place -->

            <!-- start::field groups -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3" v-if="showGroups">
              <label class="text-sm opacity-75">Ομάδα
                <vs-button @click="selectedDealerGroup = []" type="flat">Εκκαθάριση
                </vs-button>
              </label>
              <v-select :options="dealerGroups" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="selectedDealerGroup" class="mb-4 md:mb-0"/>
            </div>
            <!-- end::field groups -->

            <!-- start::field category -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <label class="text-sm opacity-75 customLabel">
                Κατηγορία
                <vs-button @click="selectedCategory = []" type="flat">
                  Εκκαθάριση
                </vs-button>
              </label>
              <v-select :options="categories" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="selectedCategory" class="mb-4 md:mb-0"/>
            </div>
            <!-- end::field category -->

            <!-- start::field prices -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3" style="display: none">
              <label class="text-sm opacity-75">Τιμές</label>
              <v-select :options="filterOption" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="selectedFilter"/>
            </div>
            <!-- end::field prices -->

          </div>

          <div class="vx-row">
            <!-- start::action download xls -->
            <div class="vx-col w-full mb-3 text-right">
              <vs-button :disabled="invalid" @click="generateReports(true)" color="primary" type="filled"
                         class="ml-auto mt-6">
                Download Xls
              </vs-button>

              <vs-button :disabled="invalid" @click="generateReports(false)" color="primary" type="filled"
                         class="ml-6 mt-6">
                Δημιουργία Report
              </vs-button>
            </div>
            <!-- end::action download xls -->

          </div>
        </form>
      </validation-observer>
    </vx-card>
    <!-- end::filter card -->

    <!-- start::grid card -->
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer" style="display: none">
            <div class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              ">
              <span class="mr-2">{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  recordsData.length - currentPage * paginationPageSize > 0
                      ? currentPage * paginationPageSize
                      : recordsData.length
                }}
                of {{ recordsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          " v-model="searchQuery" @input="updateSearchQuery" placeholder="Αναζήτηση..." style="display: none"/>

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer" style="display: none">
          <div class="
              p-3
              shadow-drop
              rounded-lg
              d-theme-dark-light-bg
              cursor-pointer
              flex
              items-end
              justify-center
              text-lg
              font-medium
              w-32
            ">
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2"/>
                <span>Delete</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2"/>
                <span>Archive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                <span>Print</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2"/>
                <span>CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="recordsData" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
                   :floatingFilter="true" :pagination="false" :sideBar="sideBar" @grid-ready="onGridReady"
                   @sort-changed="onColumnMoved" @column-visible="onColumnMoved" @column-pivot-changed="onColumnMoved"
                   @column-row-group-changed="onColumnMoved" @column-value-changed="onColumnMoved"
                   @column-pinned="onColumnMoved" @column-moved="onColumnMoved"
                   :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :enableRtl="$vs.rtl">
      </ag-grid-vue>


    </div>
    <!-- end::grid card -->

  </div>
  <!-- end::component container -->
</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererChecked from './cell-renderer/CellRendererChecked.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import axios from '@/axios'

// Validation
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο.',
})

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererChecked,
    CellRendererVerified,
    CellRendererActions,

    // Validation
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      // Filter Options
      roleFilter: {label: 'All', value: 'all'},
      selectedFilter: {label: 'Όλες οι τιμές', value: 'all'},
      filterOption: [
        {label: 'Όλες οι τιμές', value: 'all'},
        {label: 'Όλες οι χαμηλότερες τιμές', value: 'allLower'},
      ],

      searchQuery: '',
      recordsData: [],
      date: '',
      hours: [],
      eshops: [],
      dealerGroups: [],
      categories: [],
      selectedHour: null,
      selectedEshop: null,
      selectedDealerGroup: null,
      selectedCategory: null,
      // AgGrid
      gridApi: null,
      gridOptions: {
        excelStyles: [
          {
            id: 'lessPrice',
            interior: {
              color: '#FF0000',
              pattern: 'solid',
            },
          },
          {
            id: 'goodPrice',
            interior: {
              color: '#32CD32',
              pattern: 'solid',
            },
          },
          {
            id: 'samePrice',
          },
        ],
      },
      gridColumnApi: null,
      columnApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: false,
      },
      sideBar: null,
      columnDefs: [],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererChecked,
        CellRendererVerified,
        CellRendererActions,
      },
    }
  },
  computed: {
    activeDates() {
      if (this.$store.getters.getReportActiveDates && this.$store.getters.getReportActiveDates.length > 0) {
        this.date = this.$store.getters.getReportActiveDates.reduce((a, b) => {
          return new Date(a) > new Date(b) ? a : b;
        });
        this.findCrawlingSetsPerDate()
      }
      return this.$store.getters.getReportActiveDates
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
  },
  methods: {
    findCrawlingSetsPerDate() {
      let vm = this
      vm.selectedHour = null
      axios
          .post('reports/findCrawlingSetsPerDate', {date: vm.date})
          .then((response) => {
            vm.hours = response.data.object
          })
    },
    getDealerGroups() {
      let vm = this
      axios
          .get('dealersGroups/list')
          .then((response) => {
            vm.dealerGroups = response.data
          })
    },
    getEshops() {
      let vm = this
      axios
          .get('eshops/list')
          .then((response) => {
            let eshopslist = []

            response.data.forEach(function (item, index) {
              if (
                  item.name.indexOf('skroutz.gr') < 0 &&
                  item.name.indexOf('bestprice.gr') < 0 &&
                  item.name.indexOf('shopflix.gr') < 0
              ) {
              } else {
                eshopslist.push(item)
              }
              vm.eshops = eshopslist
            })

            let other = {id: -1, name: 'Όλα τα άλλα'}
            vm.eshops.push(other)
          })
          .catch((error) => {
            console.log(error)
          })
          .then((response) => {
            // alert('3)');
          })
    },
    showGroups() {
      let vm = this
      if (!vm.selectedEshop) {
        return false
      }
      if (vm.selectedEshop.name.indexOf('skroutz') >= 0) {
        return true
      } else {
        vm.selectedDealerGroup = null
        return false
      }
    },
    getCategories() {
      let vm = this
      axios
          .get('productCategories/list')
          .then((response) => {
            vm.categories = response.data
          })
          .catch((error) => {
            console.log(error)
          })
          .then((response) => {
            // alert('3)');
          })
    },
    getProductsByCategoryId() {
      let vm = this
      vm.selectedProduct = null
      axios
          .get(`products/listByCategoryId/${vm.selectedCategory.id}`)
          .then((response) => {
            vm.products = response.data
          })
    },
    makeDefaultColumns() {
      this.columnDefs = [
        {
          headerName: 'UID',
          field: 'remoteId',
          filter: 'agTextColumnFilter',
          width: 180,
        },
        {
          headerName: 'MPN',
          field: 'part_number',
          filter: 'agTextColumnFilter',
          width: 180,
        },

        {
          headerName: 'Όνομα Προϊόντος',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 325,
        },
        {
          headerName: 'Κατηγορία',
          field: 'category.name',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Τιμή',
          field: 'erp_price',
          filter: 'agTextColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            if (
                params.data.erp_price === '' ||
                params.data.erp_price === undefined ||
                params.data.erp_price === null
            ) {
              return 0
            } else {
              return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(params.data.erp_price);

              //return params.data.erp_price.toFixed(2)
            }
          },
        },
        {
          headerName: 'Τιμή με έκπτωση',
          field: 'promo_price',
          filter: 'agTextColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            if (
                params.data.promo_price === '' ||
                params.data.promo_price === undefined ||
                params.data.promo_price === null
            ) {
              return 0
            } else {
              return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(params.data.promo_price);

              //return params.data.promo_price.toFixed(2)
            }
          },
        },
      ]
    },
    makeColumns(item, index) {
      this.columnDefs.push({
        headerName: item,
        field: item,
        filter: 'agTextColumnFilter',
        width: 100,
        valueFormatter: (params) => {
          if (
              params.value === '' ||
              params.value === undefined ||
              params.value === null
          ) {
            return null
          } else {
            return new Intl.NumberFormat('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(params.value);
            //return params.value.toFixed(2)
          }
        },
        cellClass: function (params) {
          if (params.data.promo_price && params.data.promo_price > 0) {
            if (params.value < params.data.promo_price) {
              if (params.value != '') {
                return 'lessPrice'
              }
            } else if (params.value > params.data.promo_price) {
              return 'goodPrice'
            } else {
              return 'samePrice'
            }
          } else {
            if (params.value < params.data.erp_price) {
              if (params.value != '') {
                return 'lessPrice'
              }
            } else if (params.value > params.data.erp_price) {
              return 'goodPrice'
            } else {
              return 'samePrice'
            }
          }
        },
      })
    },
    generateReports(save = false) {
      let vm = this
      vm.$vs.loading()

      axios
          .post('reports/reportsByTable' + (save ? '/save' : ''), {
            group_crawl: vm.selectedHour ? vm.selectedHour.uid : null,
            eshopId: vm.selectedEshop ? vm.selectedEshop.id : null,
            categoryId: vm.selectedCategory ? vm.selectedCategory.id : null,
            dealerGroupId: vm.selectedDealerGroup
                ? vm.selectedDealerGroup.id
                : null,
            filter: vm.selectedFilter.value,
          })
          .then((response) => {
            vm.$vs.loading.close()
            if (save) {
              window.location.replace(response.data.object)
            } else {
              vm.makeDefaultColumns()
              response.data.dealers.forEach(vm.makeColumns)
              vm.recordsData = response.data.products
              console.log(vm.recordsData)
            }
          })
          .catch((error) => {
            console.log(error)
            //alert('unauthorized1')
            vm.$vs.loading.close()
          })
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.$refs.filterCard.removeRefreshAnimation()
      this.selectedHour = null
      this.selectedEshop = null
      this.selectedCategory = null
      this.selectedProduct = null
      this.date = ''
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    onColumnMoved(params) {
      this.columnState = JSON.stringify(params.columnApi.getColumnState())
      localStorage.setItem('myColumnStateTable', this.columnState)
    },
    onColumnChangeStatus(params) {
      this.columnState = JSON.stringify(params.columnApi.getColumnState())
      localStorage.setItem('myColumnStateT', this.columnState)
      //console.log(this.columnState)
    },
    loadGridState() {
      this.columnState = JSON.parse(localStorage.getItem('myColumnStateTable'))
      this.gridColumnApi.applyColumnState({
        state: this.columnState,
        applyOrder: true,
      })
    },
    onGridReady(params) {
      let vm = this
      vm.params = params
      vm.gridApi = params.api
      vm.gridColumnApi = params.columnApi
      setTimeout(() => {
        vm.loadGridState()
      }, 1000);
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
          '.ag-header-container'
      )
      header.style.left = `-${String(
          Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
  },
  created() {
    this.$store.dispatch('fetchReportActiveDates')
    this.getEshops()
    this.getCategories()
    this.getDealerGroups()
    this.date = new Date()
  },
  beforeMount() {
    this.sideBar = {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Στήλες',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressSideButtons: true,
            suppressColumnFilter: true,
            suppressColumnSelectAll: true,
            suppressColumnExpandAll: true,
          },
        },
      ],
    }
    this.columnDefs = [
      {
        headerName: 'UID',
        field: 'remoteId',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'MPN',
        field: 'part_number',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Όνομα Προϊόντος',
        field: 'name',
        filter: 'agTextColumnFilter',
        width: 325,
      },
      {
        headerName: 'Κατηγορία',
        field: 'category.name',
        filter: 'agTextColumnFilter',
        width: 150,
      },
      {
        headerName: 'Τιμή',
        field: 'erp_price',
        filter: 'agTextColumnFilter',
        cellStyle: {'text-align': 'right'},
        width: 150,
        valueFormatter: (params) => {
          if (
              params.data.erp_price === '' ||
              params.data.erp_price === undefined ||
              params.data.erp_price === null
          ) {
            return 0
          } else {
            return params.data.erp_price.toFixed(2)
          }
        },
      },
      {
        headerName: 'Τιμή με έκπτωση',
        field: 'promo_price',
        filter: 'agTextColumnFilter',
        cellStyle: {'text-align': 'right'},
        width: 150,
        valueFormatter: (params) => {
          if (
              params.data.promo_price === '' ||
              params.data.promo_price === undefined ||
              params.data.promo_price === null
          ) {
            return 0
          } else {
            return params.data.promo_price.toFixed(2)
          }
        },
      },
    ]
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.lessPrice {
  background: red;
  color: white;
}

.goodPrice {
  background: forestgreen;
  color: white;
}

.samePrice {

}

.ag-theme-material .ag-side-bar {
  border-left: 1px solid rgba(var(--vs-primary), 1);
  padding-left: 10px;
}

.vs-button-primary.vs-button-flat {
  font-size: 9px;
  padding: 5px !important;
  float: right;
}

.customLabel {
  width: 100%;
  display: inline-block;
}
</style>
